import { connect } from 'react-redux'
import SlidesUploadModal from './SlidesUploadModal'
import { hideSlidesUploadModal } from '../../dataStore/actions/ui/uiActions'
import slidesActions from '../../dataStore/actions/slides'
import { SlidesUploadModalProps } from './types'
import { State } from '../../dataStore/reducers/reducerType'

type Dispatch = 'onCancelClick' | 'onUploadClick' | 'onSetAsFeatureImage' | 'onUnsetAsFeatureImage'

const mapStateToProps = (state: State): Omit<SlidesUploadModalProps, Dispatch> => ({
  slidesSizeLimitBytes: state.config.slidesSizeLimitBytes,
  serviceError: state.slides.hasError ? state.slides.error : null,
  setAsFeatureImage: state.slides.setAsFeatureImage
})

const mapDispatchToProps = (dispatch): Pick<SlidesUploadModalProps, Dispatch> => ({
  onCancelClick: () => dispatch(hideSlidesUploadModal()),
  onUploadClick: (slidesFile) => dispatch(slidesActions.uploadSlides(slidesFile)),
  onSetAsFeatureImage: () => dispatch(slidesActions.setAsFeatureImage()),
  onUnsetAsFeatureImage: () => dispatch(slidesActions.unsetAsFeatureImage())
})

export default connect(mapStateToProps, mapDispatchToProps)(SlidesUploadModal)
